define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getEnvironment = exports.enviroment = void 0;
    var enviroment;
    (function (enviroment) {
        enviroment["DEV"] = "dev";
        enviroment["TEST"] = "Test";
        enviroment["HUIDU"] = "Huidu";
        enviroment["PROD"] = "Prod";
    })(enviroment = exports.enviroment || (exports.enviroment = {}));
    function getEnvironment(configDev, configTest, configHuidu, configProd, envConfig) {
        return configDev;
    }
    exports.getEnvironment = getEnvironment;
});
//# sourceMappingURL=BootstrapEnvironment.js.map